import { Box, Typography } from '@mui/material';
import { useState } from 'react';

import { handleApiError } from '../utils/api.utils';
import { CenteredModal, ModalTitle } from './CenteredModal';
import { LowerCaseButton } from './common';

interface IDeleteWarningModale {
  header: string;
  onClose: () => void;
  open: boolean;
  handleDelete: () => void | Promise<void>;
}

const DeleteWarningModal = ({ header, handleDelete, open, onClose }: IDeleteWarningModale) => {
  const [isDeleting, setIsDeleting] = useState(false);

  // On garde la modale ouverte tant que la suppression n'a pas abouti, pour ne pas
  // laisser croire qu'un échec a supprimé la donnée.
  const onConfirm = async () => {
    setIsDeleting(true);
    try {
      await handleDelete();
      onClose();
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <CenteredModal open={open} handleClose={onClose}>
      <ModalTitle>
        <Typography variant="h5">{header}</Typography>
      </ModalTitle>
      <Box
        component="div"
        sx={{ display: 'flex', flexDirection: 'column', gap: '16px', padding: '30px' }}
      >
        <LowerCaseButton
          variant="outlined"
          type="submit"
          disabled={isDeleting}
          onClick={onConfirm}
        >
          Supprimer
        </LowerCaseButton>
        <LowerCaseButton variant="contained" disabled={isDeleting} onClick={onClose}>
          Annuler
        </LowerCaseButton>
      </Box>
    </CenteredModal>
  );
};

export default DeleteWarningModal;
